module.exports = __webpack_public_path__ + "static/img/img-home-co-11.44426b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-11.png
// module id = DXws
// module chunks = 1